import React from 'react';
import { Box, FormControlLabel, Checkbox, Typography } from '@mui/material';

interface EmergencyPopupToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const EmergencyPopupToggle: React.FC<EmergencyPopupToggleProps> = ({
  checked,
  onChange,
}) => {
  return (
    <Box
      sx={{
        p: 3,
        bgcolor: '#EEF2FF',
        borderRadius: '24px',
        border: '1px solid #C7D2FE',
        transition: 'background-color 0.2s ease',
        '&:hover': {
          bgcolor: '#E0E7FF',
        },
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            sx={{
              '& .MuiSvgIcon-root': {
                fontSize: 28,
                borderRadius: '8px',
              },
            }}
          />
        }
        label={
          <Box>
            <Typography
              sx={{
                fontWeight: 900,
                color: '#312E81',
                fontSize: '1.125rem',
                lineHeight: 1.2,
              }}
            >
              Emergency Pop-up
            </Typography>
            <Typography
              sx={{
                fontSize: '0.75rem',
                color: '#6366F1',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                mt: 0.5,
                opacity: 0.8,
              }}
            >
              Show as priority interruption on recipient apps
            </Typography>
          </Box>
        }
        sx={{
          m: 0,
          width: '100%',
          cursor: 'pointer',
          userSelect: 'none',
        }}
      />
    </Box>
  );
};
